import { render, staticRenderFns } from "./Bip.vue?vue&type=template&id=576a6a84"
import script from "./Bip.vue?vue&type=script&lang=js"
export * from "./Bip.vue?vue&type=script&lang=js"
import style0 from "./Bip.vue?vue&type=style&index=0&id=576a6a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports